import React, { useEffect, useRef, useState } from "react";

const CustomCarousel = ({ addsList, classes }) => {
    const [index, setIndex] = useState(0);
    const intervalRef = useRef(null);

    const visibleItems = 3;         // we want 3 items always
    const itemWidth = 280;          // width of each card (px)
    const gap = 16;                 // gap between cards (px)

    const trackWidth = addsList.length * itemWidth + gap * (addsList.length - 1);
    // total track width
    const shiftAmount = index * (itemWidth + gap);           // shift by item width

    useEffect(() => {
        if (addsList.length > visibleItems) {
            intervalRef.current = setInterval(() => {
                setIndex((prev) => (prev + 1) % addsList.length);
            }, 2000);
        }
        return () => clearInterval(intervalRef.current);
    }, [addsList.length]);

    return (
        // <div style={{ overflow: "hidden"}}>
        <div
            style={{
                overflow: "hidden",
                display: "flex",
                justifyContent: addsList.length <= 3 ? "center" : "flex-start",
            }}
        >

            <div
                style={{
                    display: "flex",
                    gap: `${gap}px`,
                    width: `${trackWidth}px`,
                    transition: "transform 0.6s ease",
                    transform: `translateX(-${shiftAmount}px)`
                }}
            >
                {addsList.map((ad, i) => (
                    <div
                        key={i}
                        style={{
                            width: `${itemWidth}px`,
                            height: "150px", // fixed height (change as needed)
                            flexShrink: 0,
                        }}
                        onClick={() => ad.redirect && window.open(ad.redirect, "_blank")}
                        className={classes.bannerCard}
                    >
                        <img
                            src={ad.imgUrl}
                            alt={ad.name}
                            loading="lazy"
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "12px",
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomCarousel;
